import {ActionWithPayload} from '@catcore/types/base';
import {ResourceAction, ResourceActions} from '@catfeatures/actions/resource.actions';

const initialState = {
  resource: null,
};

export function resourceReducer(state = initialState,
                                action: ActionWithPayload<ResourceAction>) {
  let returnable = state;
  switch (action.type) {
    case ResourceActions.REQUEST_RESOURCE:
      returnable = {...state};
      break;
    case ResourceActions.LOADED_RESOURCE:
      returnable = {...state, resource: action.payload.resource};
      break;
  }

  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/reducers/resource.reducer.ts